<template>
  <div>
    <Panel :data="chronotachograph"/>
    <hr>

    <h3>Histórico de Multas</h3>
    <ChronotachographHistories v-if="chronotachograph && chronotachograph.id" :chronotachograph="chronotachograph"/>
  </div>
</template>

<script>
import ModelMapper from '@/mixins/ModelMapper'
import Panel from '../Panel.vue'
import ChronotachographHistories from './ChronotachographHistories'

import { mapMutations } from 'vuex'

export default {
  components: { Panel, ChronotachographHistories },
  computed: {
    chronotachograph() {
      return this.getModel
    },
  },
  created() {
    this.asyncTemplateShow(this.id, {
      after: ({model}) => this.setNameBreadcrumb(model.id)
    })
  },
  data: () => ({
    modelPathPrefix: 'admin/maestro',
    nameModel: 'Chronotachograph',
  }),
  methods: {
    ...mapMutations(['setNameBreadcrumb']),
  },
  mixins: [ModelMapper],
  name: 'Show',
  props: {
    id: { required: false }
  }
}

</script>

<style scoped>

</style>